import { login, logout, getInfo } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    resources: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_RESOURCES: (state, resources) => {
      state.resources = resources;
    },
  },

  actions: {
    // 登录
    Login({ commit, dispatch }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login({
          username,
          password: userInfo.password,
          uuid: userInfo.uuid,
          captcha: userInfo.captcha,
        })
          .then(response => {
            const data = response.data;
            const tokenStr = data.tokenHead + data.token;
            dispatch('ResetRoutes');
            commit('SET_ROLES', []);
            commit('SET_RESOURCES', []);
            setToken(tokenStr);
            commit('SET_TOKEN', tokenStr);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            const data = response.data;
            // 已登录但尚未分配角色也是有效账号，由菜单加载状态决定是否需要重新取权限。
            commit('SET_ROLES', Array.isArray(data.roles) ? data.roles : []);
            commit('SET_RESOURCES', Array.isArray(data.resources) ? data.resources : []);
            commit('SET_NAME', data.username);
            commit('SET_AVATAR', data.icon);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ dispatch, state }) {
      return logout(state.token).then(() => dispatch('FedLogOut'));
    },

    // 前端 登出
    FedLogOut({ commit, dispatch }) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_RESOURCES', []);
      commit('SET_NAME', '');
      commit('SET_AVATAR', '');
      removeToken();
      return dispatch('ResetRoutes');
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js